import { useIntl } from 'react-intl'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import Badge from 'LuxKit/Badge'
import FormatCurrency from 'components/Common/FormatCurrency'
import LineShoppingCartIcon from 'LuxKit/Icons/line/LineShoppingCartIcon'
import NavBarButton from 'components/NavKit/NavBarButton/NavBarButton'

interface Props {
  itemCount: number
  totalPrice: number
  onClick: () => void
}

function CartButton({ itemCount, totalPrice, onClick }: Props) {
  const intl = useIntl()

  const tripTotalLabel = intl.formatMessage({
    id: '_zfntouYbTkXbAop1b7l',
    defaultMessage: 'Trip total',
    description: 'Label for the cart button in the trip planner header showing the estimated trip total',
  })

  return (
    <NavBarButton
      onClick={onClick}
      icon={<LineShoppingCartIcon />}
      badge={<Badge kind="string" mode="highlight">{String(itemCount)}</Badge>}
    >
      <Group direction="horizontal" gap={4} verticalAlign="center">
        <BodyText variant="medium">{tripTotalLabel}</BodyText>
        <BodyText variant="medium" weight="bold">
          <FormatCurrency value={totalPrice} format="preciseDollar" />
        </BodyText>
      </Group>
    </NavBarButton>
  )
}

export default CartButton
